import { IColumnType } from '../../components/tableComponent/Table';

export const columns: (t: any) => IColumnType<any>[] = (t: any) => [
    {
        title: t('ID'),
        dataIndex: 'id',
        checkbox: true,
        menu: false,
        key: '0',
    },
    {
        title: t('Date'),
        dataIndex: 'created_at',
        type: 'date',
        key: '1',
    },
    {
        title: t('Service'),
        type: 'dropdown',
        dataIndex: 'department',
        key: '2',
    },
    {
        title: t('Photo'),
        type: 'link',
        dataIndex: 'link',
        key: '2',
        render: (_, record) => (
          <div>
              {record?.link !== null ? <a href={record?.link} target="_blank" rel="noopener noreferrer">Фото</a> : ''}
          </div>
        )
    },
    {
        title: t('CountryOfIssue'),
        dataIndex: 'country1',
        type: 'string',
        key: '3',
    },
    {
        title: t('CityOfIssue'),
        dataIndex: 'city1',
        type: 'string',
        width: 150,
        key: '4',
    },
    {
        title: t('CountryOfDelivery'),
        dataIndex: 'country2',
        type: 'string',
        key: '5',
    },
    {
        title: t('CityOfDelivery'),
        dataIndex: 'city2',
        width: 150,
        type: 'string',
        key: '6',
    },
    {
        title: t('CpcNumber'),
        dataIndex: 'col_ktk',
        type: 'string',
        maxLength: 4,
        key: '7',
    },
    {
        title: t('ContainerType'),
        dataIndex: 'type_ktk',
        type: 'dropdown',
        key: '8',
    },
    {
        title: t('Quality'),
        dataIndex: 'quality',
        type: 'dropdown',
        key: '9',
    },
    {
        title: t('Bet'),
        dataIndex: 'bet',
        type: 'range_integer',
        maxLength: 15,
        key: '10',
        render: (_, record) => {
            const bet = record?.bet === null ? record?.bet_int : record?.bet;
            const symbol = record?.symbol ?? '';

            return (
                <div>
                    {bet !== 'По запросу' ? bet === null ? bet : bet + symbol : bet}
                </div>
            );
        }
    },
    {
        title: t('Subsidy'),
        dataIndex: 'subsidy',
        type: 'string',
        maxLength: 15,
        key: '11',
    },
    {
        title: t('RatePerLift'),
        dataIndex: 'bet_1_crane',
        type: 'string',
        maxLength: 15,
        key: '12',
        render: (_, record) => (
          <div>
              {record?.bet_1_crane !== null ? record.bet_1_crane : ''}
              {record?.symbolCrane !== null ? record.symbolCrane : ''}
          </div>
        )
    },
    {
        title: t('RatePerDay'),
        dataIndex: 'bet_1_day',
        type: 'string',
        maxLength: 15,
        key: '13',
        render: (_, record) => (
          <div>
              {record?.bet_1_day !== null ? record.bet_1_day : ''}
              {record?.symbolDay !== null ? record.symbolDay : ''}
          </div>
        )
    },
    {
        title: t('FreeDays'),
        dataIndex: 'free_days',
        type: 'string',
        maxLength: 4,
        key: '14',
    },
    {
        title: t('Overdue'),
        dataIndex: 'cnp',
        type: 'string',
        maxLength: 4,
        key: '15',
    },
    {
        title: t('Comments'),
        dataIndex: 'comment',
        type: 'string',
        width: 200,
        key: '16',
    },
    {
        title: '',
        dataIndex: 'hidden',
        width: '20%',
        key: '17',
    },
];
